import CityPageTemplate from "../city-template/CityPageTemplate";
import { keeneConfig } from "./data";

export default function KeenePage() {
  return <CityPageTemplate config={keeneConfig} />;
}